/** "21 October 2026" / "2026年10月21日" for a YYYY-MM-DD changelog date. */
export function formatChangelogDate(date: string, language: 'en' | 'zh'): string {
  const [y = 1970, m = 1, d = 1] = date.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(language === 'zh' ? 'zh-CN' : 'en-AU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
